import { render, staticRenderFns } from "./CompanyChart.vue?vue&type=template&id=a97dbf6e&scoped=true&"
import script from "./CompanyChart.vue?vue&type=script&lang=js&"
export * from "./CompanyChart.vue?vue&type=script&lang=js&"
import style0 from "./CompanyChart.vue?vue&type=style&index=0&id=a97dbf6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97dbf6e",
  null
  
)

export default component.exports